import List from '../../../components/Purchasing/Voucher/VouchersList'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import { Tabs } from 'antd'
import React, { Fragment } from 'react'
import { get } from 'lodash'
import VouchersLinesList from '../../../components/Purchasing/Voucher/VouchersLinesList'
import { withRouter } from 'react-router-dom'

const { Content } = Layout
const { TabPane } = Tabs

function Vouchers(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/vouchers">Vendors</Breadcrumb.Item>
              <Breadcrumb.Item>Vendors</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle title={'Vouchers'} subtitle={'Supplier Invoices'} color={'#FF6138'} iconType={'file-pdf'} />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <Tabs
              defaultActiveKey={get(props, 'location.hash') || '#list'}
              onChange={(key) => props.history.push(key)}
              tabPosition={'top'}>
              <TabPane tab="Vouchers" key="#list">
                <List {...props} />
              </TabPane>
              <TabPane tab="Vouchers Lines" key="#voucher-lines-list">
                <VouchersLinesList {...props} />
              </TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Vouchers.propTypes = {}
Vouchers.defaultProps = {}

export default withRouter(Vouchers)
